<template>
    <div class="tariffs">
        <div class="container">
            <div class="tariff__header-descriptions" v-if="showHeader">
                <h1 class="title title--sm ">
                    {{ $lang("ПОДПИСКА НА ДРЕВО") }}
                </h1>
                <el-switch :inactive-text="$lang('Подписка на древо с выгодой до 20%')"
                           style="flex-direction: row-reverse; gap: 10px"
                           class="a-popover__switch switch switch--small popover-hover" v-model="isTabTree" @change=change>
                </el-switch>
            </div>
            <swiper @sliderMove="closePopovers" class="tariffs__swiper" :options="swiperOptions">
                <swiper-slide v-for="(tariff, index) in tariffs"
                              :class="{ 'tariffs__block-tree': !tariff.superActive, 'tariffs__block-tree--super-active': tariff.superActive, }"
                              :key="index" v-if="isVisible(tariff, index)">
                    <div class="tariffs__active-msg--tree" v-if="tariff.active">
                        {{ tariff.activeMsg }}
                    </div>

                    <div class="tariffs__header--tree">
                        <h2 class="title title--uppercase title--xs tariffs__item-title"
                            :class="tariff.superActive ? 'color-white' : ''">
                            {{ tariff.name }}
                        </h2>
                        <p v-if="tariff.coast" :class="tariff.superActive ? 'color-white header__coast-under--secondary' : ''"
                           class="header__coast-under">{{ tariff.coast }}</p>

                    </div>

                    <div class="tariffs__bottom">
                        <div class="title title--bold title--sl" :class="tariff.superActive ? 'color-white' : ''">
                            <span :class="tariff.superActive ? 'color-white' : ''" class="tariffs-price">{{ tariff.price }}</span>
                        </div>

                        <a :class="tariff.superActive ? 'backgroundWhite' : ''"
                           class="btn btn--main-bg btn--middle tariffs__btn"
                           @click.stop="selectSubscription(tariff, tariff.id)">
                            {{ buttonName(index) }}
                        </a>
                    </div>

                    <div class="tariffs__content">

                        <ul class="tariffs__a-options">
                            <li class="tariffs__a-options-item" v-for="option in tariff.additionalOptions">
                                <svg class="tariffs__a-options-icon" width="25" height="25">
                                    <use :xlink:href="'/assets/front/img/sprite.svg#icon-' +
                                        option.icon
                                        "></use>
                                </svg>

                                <div>
                                    <span :class="tariff.superActive ? 'color-white' : ''"
                                          class="tariffs__a-options-name--tree" v-html="option.name"></span>

                                    <el-popover class="tariffs__popover" placement="bottom" ref="popovers"
                                                v-if="option.popover" width="290" trigger="hover" :content="option.popover">
                                        <img class="tariffs__popover--icon" slot="reference"
                                             src="/assets/front/img/popover.svg" alt="#" />
                                    </el-popover>

                                    <p v-if="option.desc" class="tariffs__a-options-desc--tree"
                                       :class="tariff.superActive ? 'color-turquoise' : ''">
                                        {{ option.desc }}
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="tariff__bottom">
                        <div :class="tariff.superActive ? 'color-freshAir' : ''" class="tariff__bottom-separator"></div>
                        <div class="tariff__botom-block">
                            <p :class="tariff.superActive ? 'color-turquoise' : ''" class="tariff__bottom-text">
                                Нажимая кнопку "Оплатить", Вы подтверждаете, что ознакомлены с положениями
                                <a href="/assets/front/pdf/memorycode_oferta.pdf"
                                   :class="tariff.superActive ? 'color-turquoise' : ''"
                                   class="tariff__bottom-text tariff__botom-link">
                                    Публичного договора - оферты ООО "Код Памяти"
                                </a>
                                и принимаете их
                            </p>
                        </div>
                    </div>

                </swiper-slide>
            </swiper>
        </div>
        <el-dialog class="popup popup--success" :width="windowWidth > 992 ? '770px' : '75%'" top="50vh"
                   :append-to-body="true" :show-close="false" :visible.sync="show">
            <div class="popup__success">
                <span> Подписка уже оформлена </span>
            </div>
        </el-dialog>

        <el-dialog :width="windowWidth > 992 ? '770px' : '100%'" :top="windowWidth > 992 ? '15vh' : '0px'"
                   :visible.sync="isFormVisible" :append-to-body="true">
            <div class="popup__header">
                <span class="title title--sm popup__title">ОПЛАТА ПОДПИСКИ</span>
                <button class="btn popup__close popup__close--fixed" @click.prevent="isFormVisible = false">
                    <i class="el-icon-close"></i>
                </button>
            </div>

            <div class="popup__content subscribe__popup">

                <div class="subscription-form__price subscription-form__info">
                    <span class="order__price-name">{{ selectedTariff.name }}</span>
                    <div class="order__price-count">{{ selectedTariff.price }} ₽</div>
                </div>

                <div class="order__total">
                    <div>{{ $lang('Delivery.order.sum') }} </div>
                    <div class="order__total-price">
                        {{ selectedTariff.price }} ₽
                    </div>
                </div>

                <div class="order__promo-code-title">укажите ваш e-mail, мы вышлем на него чек и информацию о подписке
                </div>

                <form class="ainoxform" @submit.prevent="submitForm">
                    <el-input type="email" v-model="form.email" class="input input--big" required
                              :placeholder="$lang('email.input.placeholder')" />
                    <button type="submit" class="btn btn--main-bg btn--middle subscription__btn">{{
                            $lang('Delivery.order.pay') }}</button>
                </form>

                <div class="subscription__policy">
                    Нажимая кнопку "Оплатить", Вы подтверждаете, что
                    ознакомлены с положениями
                    <a href="/assets/front/pdf/memorycode_oferta.pdf" class="subscription-link" target="_blank">
                        Публичного договора - оферты ООО "Код Памяти"
                    </a>
                    и принимаете их
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Vue from "vue";
import ApiService from "../api/api";
import Subscription from "./Subscription.vue";
import { mapGetters, mapMutations } from "vuex";

export default {
    name: "SubscribeTree",
    components: { Subscription },
    props: {
        showHeader: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isSubscrTree: false,
            subscription: window.laravel.subscription || null,
            currency: window.laravel.prices.currency.symbol,
            show: false,
            selectedTariff: {},
            isFormVisible: false,
            form: {
                email: laravel.user ? laravel.user.email : '',
                tariff: {},
            },
            swiperOptions: {
                slidesPerView: 1,
                spaceBetween: 15,
                breakpoints: {
                    300: {
                        slidesPerView: 1.2,
                        spaceBetween: 15
                    },
                    550: {
                        slidesPerView: 2.2,
                        spaceBetween: 15
                    },
                    900: {
                        slidesPerView: 3.2,
                        spaceBetween: 15
                    },
                }
            },
            tariffs: [
                {
                    id: 1,
                    name: "МОЕ ДРЕВО",
                    example: window.laravel.pagesExamples.short,
                    price: "299 ₽ / МЕС.",
                    route: "free",
                    options: {
                        width: null,
                        height: null,
                        icon: null,
                        text: Vue.prototype.$lang("tariffs.options")
                    },
                    subscription_type_id:
                    window.laravel.subscriptionTypes[0].id,
                    additionalOptions: [
                        {
                            icon: "lock_tariff",
                            name: "Доступ ко всему функционалу древа памяти"
                        },
                        {
                            icon: "free_page_tariff",
                            name: "Бесплатно: 10 расширенных страниц без физических куар-кодов",
                            desc: "Вы сможете расширить до 10 кратких страниц \n" +
                                "и получить расширенные страницы памяти \n" +
                                "без физических куар-кодов"
                        },
                        {
                            icon: "help_tree_tariff",
                            name: "Приоритетная поддержка от нашей службы заботы",
                            desc: "Наши специалисты поддержки внимательно выслушают ваш вопрос и ответят максимально точно и без очереди"
                        },
                        {
                            icon: "ai_bio",
                            name: "AI - написание биографии",
                            desc: "Телеграм бот для помощи в заполнении страницы памяти на базе AI YandexGPT с распознаванием голосовых записей - расскажите о своих родственниках, остальное бот сделает сам"
                        },
                    ],
                    coast: null,
                    active: false,
                    superActive: false,
                    paymentType: window.laravel.paymentTypes.page,
                    copyright: false
                },
                {
                    id: 2,
                    name: "МОЕ ДРЕВО +",
                    example: window.laravel.pagesExamples.full,
                    price: "399 ₽ / МЕС.",
                    route: "pay",
                    options: {
                        width: 99,
                        height: 27,
                        icon: "tariffs_all_short",
                        text: Vue.prototype.$lang("tariffs.col2.allInShort")
                    },
                    subscription_type_id:
                    window.laravel.subscriptionTypes[1].id,
                    additionalOptions: [
                        {
                            icon: "lock_tariff",
                            name: "Доступ ко всему функционалу древа памяти"
                        },
                        {
                            icon: "free_page_tariff",
                            name: 'Бесплатно: ' + '<span class="subscription__text-blue">' + 'неограниченное' + '</span>' + ' число расширенных страниц',
                            desc: "Вы сможете расширить любое число кратких страниц и получить расширенные страницы памяти без физических куар-кодов"
                        },
                        {
                            icon: "help_tree_tariff",
                            name: "Приоритетная поддержка от нашей службы заботы",
                            desc: "Наши специалисты поддержки внимательно выслушают ваш вопрос и ответят максимально точно и без очереди"
                        },
                        {
                            icon: "ai_bio",
                            name: "AI - написание биографии",
                            desc: "Телеграм бот для помощи в заполнении страницы памяти на базе AI YandexGPT с распознаванием голосовых записей - расскажите о своих родственниках, остальное бот сделает сам"
                        },
                    ],
                    coast: "499 ₽ / мес.",
                    active: true,
                    superActive: false,
                    activeMsg: 'Выбирают 67% пользователей ',
                    paymentType: window.laravel.paymentTypes.page,
                    copyright: false
                },
                {
                    id: 3,
                    name: "МОЕ ДРЕВО + (НА ГОД)",
                    example: window.laravel.pagesExamples.fullWithCopyright,
                    price: "3990 ₽ / ГОД",
                    route: "pay",
                    options: {
                        width: 207,
                        height: 28,
                        icon: "tariffs_all_full",
                        text: "tariffs.col3.allInFull"
                    },
                    subscription_type_id:
                    window.laravel.subscriptionTypes[2].id,
                    additionalOptions: [
                        {
                            icon: "lock_tariff_black",
                            name: "Доступ ко всему функционалу древа памяти",
                        },
                        {
                            icon: "free_page_tariff_black",
                            name: "Бесплатно: неограниченное число расширенных страниц",
                            desc: "Вы сможете расширить любое число кратких страниц и получить расширенные страницы памяти без физических куар-кодов"
                        },
                        {
                            icon: "help_tree_tariff_black",
                            name: "Приоритетная поддержка от нашей службы заботы",
                            // desc: "Наши специалисты поддержки внимательно выслушают ваш вопрос и ответят максимально точно и без очереди"
                        },
                        {
                            name: "AI - написание биографии",
                            icon: "ai_bio_blue",
                        },
                        {
                            icon: "tree_tariff_black",
                            name: "При оплате за год, мы посадим от вашего имени настоящее дерево, в сотрудничестве с проектом \"Посади лес\"",
                            desc: "Вы получите сертификат о своем вкладе в лесовосстановление. А после посадки дерева, \n" +
                                "на электронную почту придет  отчет с описанием акции, фотографиями, видеороликом \n" +
                                "и GPS-координатами восстановленного участка."
                        }
                    ],
                    coast: "5988 ₽ / год",
                    active: true,
                    superActive: true,
                    activeMsg: 'Выгоднее на 20%',
                    paymentType: window.laravel.paymentTypes.page,
                    copyright: true
                },
            ],
            isMaster: window.laravel.isMaster,
            isPartner: window.laravel.isPartner,
            promoCode: null,
        };
    },
    mounted() {
        if (window.laravel.promoCode) {
            this.getPromoCode();
        }

        const subscriptionType = this.$route.query.subscriptionType;

        if (subscriptionType) {
            const type = parseInt(subscriptionType);

            const selectedTariff = this.tariffs.find(t => t.id === type);

            if (selectedTariff) {
                this.selectSubscription(selectedTariff, selectedTariff.id);
            }
        }
        else if (this.$route.query.hasOwnProperty('selectedTarif')) {
            this.selectSubscription(this.tariffs[this.$route.query.selectedTarif]);
        }
    },

    computed: {
        ...mapGetters('subscribe', {
            isTabTree: 'isTabTree'
        }),
    },
    methods: {
        ...mapMutations('subscribe', [
            'setSwitchTab',
        ]),
        change(event) {
            this.setSwitchTab(event);
        },
        isVisible(tariff, index) {
            return !(index !== 0 && tariff.price === 0);
        },
        buttonName(index) {
            return Vue.prototype.$lang("tariffs.button.pay");
        },
        closePopovers(swiper, event) {
            this.$refs.popovers.forEach(item => item.doClose());
        },
        getPromoCode() {
            ApiService.get("/promo-codes/showBy", {
                utm: window.laravel.promoCode
            }).then(response => {
                this.promoCode = response.data;
            });
        },
        showModalSubscription() {
            this.show = true
            setTimeout(() => {
                this.show = false
            }, 2000)
        },
        selectSubscription(tariff, key) {
            const now = new Date();
            const isActive = this.subscription &&
                this.subscription.active_at &&
                (this.subscription.finished_at === null || new Date(this.subscription.finished_at) > now);

            if (isActive) {
                this.showModalSubscription()
            }
            else {
                if (!laravel.user) {
                    let selectedId = this.tariffs.map((el) => el.id === key).indexOf(true);
                    let routeAfterRedirect = this.$router.resolve({ name: 'prices' }).href;

                    routeAfterRedirect += '?isSubscriptionSelected=1&';
                    routeAfterRedirect += 'selectedTarif=' + selectedId;

                    this.$router.push({name: 'login', query: { redirect: routeAfterRedirect }});
                }

                this.isFormVisible = true;
                this.selectedTariff = tariff;
                this.form.type = tariff.subscription_type_id;
            }
        },
        submitForm() {
            ApiService.post('/subscribe', this.form).then((Response) => {
                let data = Response.data;
                sessionStorage.removeItem("isWaitingClosed");

                if (data.success && data.oplata) {
                    window.location = data.url;
                }
            }).catch((error) => {
                console.error(error);
            });
        }
    }
};
</script>
